export default "__VITE_ASSET__Derkt2_j__"